module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day03_03_stay-4963dc8a1ccecb7eca3ad0fea2063088.jpg";